module.exports = __webpack_public_path__ + "static/img/hili.d794ff8.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/hili.jpg
// module id = mGpe
// module chunks = 2